import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import RootErrorBoundary from './components/RootErrorBoundary';
import redditPixel from './utils/redditPixel';
import googleAds from './utils/googleAds';

// Ad-platform boot — Reddit Pixel fires PageVisit, Google Ads
// installs the gtag.js loader. Both no-op silently when their
// respective env vars are unset (local dev / CI), so safe to call
// unconditionally here. Conversion-specific events
// (SignUp/TrialStarted/Purchase) fire from App.jsx callsites later.
redditPixel.init();
googleAds.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);